import React, { useState, useEffect } from 'react';
import DashboardHeader from '../shared/components/DashboardHeader';
import SideMenu from '../shared/components/SideMenu';
import Footer from '../shared/components/Footer';

import HttpCall from '../api/Http';
import SerializeClass from '../shared/Utils/serialized';
import User from '../shared/Utils/User';
import axios from 'axios';
import swal from 'sweetalert';
import Alert from '../shared/Utils/AlertBox';
import Moment from 'react-moment';

export default function Account() {

  const [accountList, setAccountList] = useState([])
  const [accountID, setaccountID] = useState(0);
  const [loader, setLoader] = useState(false);

  const [inputValue, setInputValue] = useState({ email: "", name: "", website: "" });
  const { email, name, website } = inputValue;

  const user = User.getUser()

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputValue((prev) => ({ ...prev, [name]: value, }));
  };

  useEffect(() => {
    getAccountList();

  }, [])

  const getAccountList = () => {
    let arr = [];
    arr.push({ P_user_id: user[0].Id });
    let p = SerializeClass.getSerializedData(arr);
    let header = {
      headers: { 'Authorization': `Token ${user[0].token}` }
    };
    let url = `https://api.getbound.ai/api/user/getUserAccounts?Params=${p}`;
    axios.get(url, header).then(response => {
      if (response.data.code == 200) {
        setAccountList(response.data.data);
      } else {
        swal({
          title: "Error!",
          text: response.data.msg,
          icon: "error",
          button: "Ok",
        })
      }
    }).catch(err => {
      console.log(err);
    })
  }

  function addAccount(e) {
    e.preventDefault();
    let url = `/api/user/addUserAccount`;
    let requestData = new FormData();
    let arr = [];
    arr.push({ P_account_name: name });
    arr.push({ P_email: email });
    arr.push({ P_website: website });

    if (accountID > 0) {
      arr.push({ P_id: accountID });
      arr.push({ P_updated_by: user[0].Id });
      url = `/api/user/updateUserAccount`;
    } else {
      arr.push({ P_user_id: user[0].Id });
      arr.push({ P_created_by: user[0].Id });
    }

    let p = SerializeClass.getSerializedData(arr);
    requestData.append('Params', p);
    setLoader(true)
    HttpCall.postRequest2(url, requestData).then(response => {
      setLoader(false)
      if (response.data.code == 200) {
        Alert.show("Success!", accountID ? "Account Name Updated Successfully." : "Account Name Added Successfully.", "success");
        getAccountList();
        setInputValue(() => ({ name: '', email: '', website: '' }))
      } else {
        swal({
          title: "Error!",
          text: response.data.msg,
          icon: "error",
          button: "Ok",
        })
      }
    }).catch(err => {
      setLoader(false)
      console.log(err);
    })
  }

  function editAccount(row) {
    setaccountID(row.id);
    setInputValue(() => ({ name: row.account_name, email: row.email, website: row.website }))
  }

  return (
    <>
      <DashboardHeader />
      <div className="container-fluid page-body-wrapper">

        <SideMenu />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row">
              <div className="col-md-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Accounts > Add Account</h4>
                    <p className="card-description">
                      Note: Add your potential account here
                    </p>
                    <form className="forms-sample">

                      <div className="form-group">
                        <label htmlFor="exampleInputAccountName1">Account Name</label>
                        <input type="email" className="form-control form-control-lg"
                          id="exampleInputAccountName1" placeholder="Account Name"
                          onChange={handleChange} value={name} name="name" />
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Email address</label>
                        <input type="email" className="form-control form-control-lg"
                          id="exampleInputEmail1" placeholder="example@email.com"
                          onChange={handleChange} value={email} name="email" />
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputWebsite1">Website</label>
                        <input type="text" className="form-control form-control-lg"
                          id="exampleInputWebsite1" placeholder="https://exmaple.com/"
                          onChange={handleChange} value={website} name="website"
                        />
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <button type="submit" className="btn btn-primary me-2 savebtn" onClick={addAccount}>ADD</button>
                        </div>
                        <div className="col-md-6">
                          <button className="btn btn-light me-2 savebtn">Cancel</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Accounts </h4>

                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Account Name</th>
                            <th>Email Address</th>
                            <th>Website</th>
                            <th>Created</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {accountList.length > 0 && accountList.map((data, index) => (<tr key={index}>
                            <td>{index + 1}</td>
                            <td>{data.account_name}</td>
                            <td>{data.email}</td>
                            <td>{data.website}</td>
                            <td><Moment format="DD-MM-YYYY">{data.created_on}</Moment></td>
                            <td>
                              <button type="submit" className="btn btn-primary me-2 savebtn" onClick={() => editAccount(data)}>Edit</button>
                            </td>
                          </tr>))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>

  )
}